import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FindRepForm from './FindRepForm';

const AnimationContainer = styled.div`
    &.transition-enter {
        opacity: 0;
    }

    &.transition-enter.transition-enter-active {
        transition: opacity 0.35s;
        transition-timing-function: ease-out;
        opacity: 1;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit.transition-exit-active {
        transition: opacity 0.25s;
        transition-timing-function: ease-out;
        opacity: 0;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 2;
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = styled.div`
    width: 436px;
    height: 234px;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(42, 42, 42, 0.1);
    padding: 1.5em;
    background-color: rgba(255, 255, 255, 1);

    @media (max-width: 30em) {
        width: 98%;
    }
`;
const FindLocalRepPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <FindRepForm
                    onBack={props.hideFindRepPopup}
                    onSubmit={data =>
                        props.onSubmit(data.homeAddressInput + ' ' + data.postalCodeInput)
                    }
                />
            </Body>
        </Container>
    </AnimationContainer>
);

FindLocalRepPopup.propTypes = {
    hideFindRepPopup: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default FindLocalRepPopup;



// WEBPACK FOOTER //
// ./src/components/LocalRep/FindLocalRepPopup.jsx